import {
  Appointment,
  DocumentTemplate,
  PatientDocument,
  User,
} from "@/src/data/allTypes";
import { getName, getUserId, getUserShortName } from "@/src/utils/utils";
import moment from "moment";
import { openEditor } from "../documents/documentsHook";
import apiFetch from "@/src/utils/apiFetch";

export default async function printCalendarDay({
  userId,
  date,
  appointments,
}: {
  userId: string | null | undefined;
  date: string;
  appointments: Appointment[];
}) {
  let user: User | null | undefined = null;
  try {
    user = await apiFetch("users", "loadById", { id: userId });
  } catch (e) {
    console.log("Impossible de récupérer l'utilisateur");
  }

  let dateAppointments = appointments
    .filter((a) => moment(a.start).isSame(date, "day"))
    .sort((a, b) => (moment(a.start).isBefore(moment(b.start)) ? -1 : 1));

  let content = `
    ${dateAppointments
      .map(
        (appointment) =>
          `<div class="c2" ><div style="white-space: nowrap;">
              - <strong>${getName(appointment.patient)}</strong> ${
            appointment.type?.name
          } ${
            appointment.patient?.phoneNumber || ""
          } <span class="gray">à ${moment(appointment.start).format(
            "HH:mm"
          )}</span></div><div class="right" style="white-space: nowrap;"> 
                <span class="gray">Ajouté le ${moment(appointment._date).format(
                  "LL"
                )} par ${getUserShortName(appointment.creator)}</span>
              </div></div>`
      )
      .join("")}
  `;

  let documentTemplate: DocumentTemplate = {
    name: `Programme du ${moment(date).format("LL")}`,
    title: `Programme du ${moment(date).format("LL")}\n${
      getUserShortName(user) || ""
    }`,
    type: "standard",
    format: "a4",
    content: "",
    reference: null,
    creator: getUserId(),
    showHeader: true,
    showLeftBar: true,
    showTitle: true,
    showPatientIdentity: false,
    isValidatable: false,
    barcodeLocation: "none",
    parent: null,
  };

  let patientDocument: PatientDocument = {
    patient: null,
    creator: getUserId(),
    template: documentTemplate,
    title: documentTemplate.title,
    content: content,
    status: "pending",
    refAnswer: null,
  };
  openEditor({
    patient: null,
    patientDocument,
  });
}
